<template>
  <v-dialog v-if="showDialog" v-model="showDialog" max-width="500px" persistent>
      <v-card class="pa-4">
          <div>
              <v-card-title>
                  <h2 class="title">Edit Shift Start/End Address</h2>
              </v-card-title>
              <div v-if="loading" class="ma-4">
                <v-progress-linear
                :indeterminate="loading"
                :class="{ 'no-opacity': !loading }"
                style="height: 2px;"
                ></v-progress-linear>
              </div>
              <template v-else>             
                <div class="py-4 px-6">
                  <v-checkbox
                    v-if="items.edit === 'all'"
                    class="mt-0"
                    label="Set start/end address based on service days"
                    :disabled="saveLoading"
                    v-model="basedOnServiceDays"
                  ></v-checkbox>
                  <div v-for="(day, index) in preparedData" :key="index">
                    <div 
                      v-if="
                        (items.edit === 'all' && basedOnServiceDays) || 
                        (items.edit === 'all' && !basedOnServiceDays && index === 0) ||
                        (items.edit === 'single' && items.day === index)">
                      <template v-if="basedOnServiceDays">
                        <div class="dialog-heading mb-4 mt-2">
                          {{ days.find(i => i.id === Number(day.day) + 1).name }}
                        </div>
                        <div class="px-2 mb-3">Shift Start Address</div>
                      </template>
                      <div v-else class="dialog-heading mb-4 mt-2">Shift Start Address</div>
                      <v-flex class="xs12 px-2">
                        <v-text-field
                          label="Address"
                          v-model="preparedData[index].start_address"
                          placeholder="Please Enter"
                          clearable
                          append-icon="search"
                          @click:append="vEmit({ name: 'SearchAddress', data: `startShiftLocation-${index}` })"
                          ref="startShiftAddress"
                          :error-messages="errors($v.preparedData.$each.$iter[index].start_address) || server_errors[`locations.${index}.start_address`]"
                          @blur="$v.preparedData.$each.$iter[index].start_address.$touch()"
                          @focus="resetServerValidation"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="xs12 px-2">
                        <v-text-field
                          label="City"
                          v-model="preparedData[index].start_city"
                          placeholder="Please Enter"
                          clearable
                          :error-messages="errors($v.preparedData.$each.$iter[index].start_city) || server_errors[`locations.${index}.start_city`]"
                          @blur="$v.preparedData.$each.$iter[index].start_city.$touch()"
                          @focus="resetServerValidation"
                        ></v-text-field>
                      </v-flex>
                      <v-layout class="px-2">
                        <v-flex xs8>
                          <v-autocomplete
                            :items="states"
                            label="State"
                            item-text="full_name"
                            item-value="name"
                            v-model="preparedData[index].start_state"
                            placeholder="Please Select"
                            clearable
                            :error-messages="errors($v.preparedData.$each.$iter[index].start_state) || server_errors[`locations.${index}.start_state`]"
                            @blur="$v.preparedData.$each.$iter[index].start_state.$touch()"
                            @focus="resetServerValidation"
                          >
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs4 class="ml-4">
                          <v-text-field
                            label="ZIP Code"
                            v-model="preparedData[index].start_zip"
                            placeholder="Please Enter"
                            clearable
                            v-mask="'#####'"
                            :error-messages="errors($v.preparedData.$each.$iter[index].start_zip) || server_errors[`locations.${index}.start_zip`]"
                            @blur="$v.preparedData.$each.$iter[index].start_zip.$touch()"
                            @focus="resetServerValidation"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <div v-if="basedOnServiceDays" class="px-2 mb-3 mt-3">Shift End Address</div>
                      <div v-else class="dialog-heading mb-4 mt-2">Shift End Address</div>
                      <v-flex class="xs12 px-2">
                        <v-text-field
                          label="Address"
                          v-model="preparedData[index].end_address"
                          placeholder="Please Enter"
                          clearable
                          append-icon="search"
                          @click:append="vEmit({ name: 'SearchAddress', data: `endShiftLocation-${index}` })"
                          ref="endShiftAddress"
                          :error-messages="errors($v.preparedData.$each.$iter[index].end_address) || server_errors[`locations.${index}.end_address`]"
                          @blur="$v.preparedData.$each.$iter[index].end_address.$touch()"
                          @focus="resetServerValidation"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="xs12 px-2">
                        <v-text-field
                          label="City"
                          v-model="preparedData[index].end_city"
                          placeholder="Please Enter"
                          clearable
                          :error-messages="errors($v.preparedData.$each.$iter[index].end_city) || server_errors[`locations.${index}.end_city`]"
                          @blur="$v.preparedData.$each.$iter[index].end_city.$touch()"
                          @focus="resetServerValidation"
                        ></v-text-field>
                      </v-flex>
                      <v-layout class="px-2">
                          <v-flex xs8>
                            <v-autocomplete
                              :items="states"
                              label="State"
                              item-text="full_name"
                              item-value="name"
                              v-model="preparedData[index].end_state"
                              placeholder="Please Select"
                              clearable
                              :error-messages="errors($v.preparedData.$each.$iter[index].end_state) || server_errors[`locations.${index}.end_state`]"
                              @blur="$v.preparedData.$each.$iter[index].end_state.$touch()"
                              @focus="resetServerValidation"
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs4 class="ml-4">
                            <v-text-field
                              label="ZIP Code"
                              v-model="preparedData[index].end_zip"
                              placeholder="Please Enter"
                              clearable
                              v-mask="'#####'"
                              :error-messages="errors($v.preparedData.$each.$iter[index].end_zip) || server_errors[`locations.${index}.end_zip`]"
                              @blur="$v.preparedData.$each.$iter[index].end_zip.$touch()"
                              @focus="resetServerValidation"
                            ></v-text-field>
                          </v-flex>
                      </v-layout>
                    </div>
                  </div>
                  <v-alert class="pa-2 mt-4" :value="$v.preparedData.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                      <span class="caption">Please fill out all fields correctly</span>
                  </v-alert>
                  <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                      <span class="caption">{{ serverValidationMessage }}</span>
                  </v-alert>
                </div>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="saveLoading" @click="EditShiftAddress">Save</v-btn>
                </v-card-actions>
              </template>
          </div>
      </v-card>
      <search-address @done="fillAddress"></search-address>
  </v-dialog>
</template>

<script>
import ApiService from "@/common/api.service"
import { validationMixin } from 'vuelidate'
import { required, helpers } from 'vuelidate/lib/validators'
import { valMessages, getValMessage } from '@/common/error-messages'
import { mask } from 'vue-the-mask'
import SearchAddress from "@/components/SearchAddress/SearchAddress"
import { mapActions } from 'vuex'

const validations = {
  preparedData: {
    $each: {
      start_address: {
        required,
        noCommas: v => !helpers.req(v) || !v.includes(','),
        noAmpersandCharacters: v => !helpers.req(v) || !v.includes('&')
        // noSpecialCharacters: v => !helpers.req(v) || !/[^-_A-Za-z0-9 #]+/g.test(v)
      },
      start_city: {
        required,
        noCommas: v => !helpers.req(v) || !v.includes(','),
        noAmpersandCharacters: v => !helpers.req(v) || !v.includes('&')
        // noSpecialCharacters: v => !helpers.req(v) || !/[^-_A-Za-z0-9 #]+/g.test(v)
      },
      start_state: { required },
      start_zip: {
        required,
        zipCode: v => !helpers.req(v) || /^\d{5}$/.test(v) 
      },
      end_address: {
        required,
        noCommas: v => !helpers.req(v) || !v.includes(','),
        noAmpersandCharacters: v => !helpers.req(v) || !v.includes('&')
        // noSpecialCharacters: v => !helpers.req(v) || !/[^-_A-Za-z0-9 #]+/g.test(v)
      },
      end_city: {
        required,
        noCommas: v => !helpers.req(v) || !v.includes(','),
        noAmpersandCharacters: v => !helpers.req(v) || !v.includes('&')
        // noSpecialCharacters: v => !helpers.req(v) || !/[^-_A-Za-z0-9 #]+/g.test(v)
      },
      end_state: { required },
      end_zip: {
        required,
        zipCode: v => !helpers.req(v) || /^\d{5}$/.test(v)
      },
    }
  }
}

export default {
  name: 'EditShiftAddress',
  mixins: [validationMixin],
  directives: {mask},
  validations,
  components: {
    SearchAddress
  },
  data() {
    return {
      no_data: [null, '', undefined, 'null'],
      states: [],
      items: null,
      loading: false,
      showDialog: false,
      preparedData: {},
      saveLoading: false,
      basedOnServiceDays: true,
      days: [
        { id: 1, name: 'Monday', short: 'Mon'},
        { id: 2, name: 'Tuesday', short: 'Tue'},
        { id: 3, name: 'Wednesday', short: 'Wed'},
        { id: 4, name: 'Thursday', short: 'Thu'},
        { id: 5, name: 'Friday', short: 'Fri'},
        { id: 6, name: 'Saturday', short: 'Sat'},
        { id: 7, name: 'Sunday', short: 'Sun'},
      ],
      serverValidation: true,
      serverValidationMessage: 'Oops something went wrong...',
      server_errors: {},
      unsubscribe: null
    }
  },
  mounted() {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'EditShiftAddress') {
          this.openModal(action.payload.data)
      }
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    ...mapActions(['vEmit']),
    getStates() {
      this.loading = true
      ApiService.get('/states')
        .then(response => {
          this.states = response.data.states;
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    openModal(data) {
      this.items = _.cloneDeep(data)
      if(this.items.edit === 'all') {
        const mappedItems = this.items.items.map(i => {
          return `${i.start_address
                  },${i.start_city
                  },${i.start_state
                  },${i.start_zip
                  },${i.end_address
                  },${i.end_city
                  },${i.end_state
                  },${i.end_zip}`
        })
        const uniqueItems = [...new Set(mappedItems)]
        this.basedOnServiceDays = uniqueItems.length > 1
      } else {
        this.basedOnServiceDays = true
      }
      this.preparedData = _.cloneDeep(data.items)
      this.$v.$reset()
      this.resetServerValidation()
      this.showDialog = true
      this.saveLoading = false
      this.getStates()
    },
    fillAllDays () {
      this.preparedData.forEach((i, index) => {
        if(index !== 0) {
          i.start_address = this.preparedData[0].start_address
          i.start_city = this.preparedData[0].start_city
          i.start_state = this.preparedData[0].start_state
          i.start_zip = this.preparedData[0].start_zip
          i.end_address = this.preparedData[0].end_address
          i.end_city = this.preparedData[0].end_city
          i.end_state = this.preparedData[0].end_state
          i.end_zip = this.preparedData[0].end_zip
        }
      })
    },
    EditShiftAddress() {
      this.resetServerValidation()
      if(!this.basedOnServiceDays) this.fillAllDays()
      this.$v.preparedData.$touch()
      if (!this.$v.preparedData.$invalid) {
        const allowed = [
          "employee_id",
          "start_address",
          "start_zip",
          "start_city",
          "start_state",
          "end_address",
          "end_zip",
          "end_city",
          "end_state",
          "id",
          "day"
        ]
        const body = {
          locations: this.preparedData.map(i => _.pick(i, allowed)) 
        }
        this.saveLoading = true

        ApiService.put(`/employee/location/${this.$route.params.id}`, body)
          .then(response => {
            this.saveLoading = false;
            this.vEmit({ 
              name: "notification", 
              data: {
                status: "success",
                text: "Shift Start/End Address have been successfully edited."
              }
            });
            this.$emit('done');
            this.closeModal();
          })
          .catch(({ response }) => {
            this.saveLoading = false;
            this.serverValidation = false;
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(response.data.error);
            }
            if (response.data.message) {
              this.serverValidationMessage = response.data.message;
            }
            if (response.data.errors) {
              this.server_errors = response.data.errors;
            }
          });
      }
    },
    closeModal() {
      this.showDialog = false;
    },
    fillAddress (input) {
      if(input.field.includes('startShiftLocation')) {
        const index = input.field.split("-")[1]
        this.preparedData[index].start_address = input.address
        this.preparedData[index].start_city = input.city
        if(this.states.some(i => i.name === input.state)) {
        this.preparedData[index].start_state = this.states.find(i => i.name === input.state).name
        }
        this.preparedData[index].start_zip = input.zip_code
        this.$refs.startShiftAddress[index].focus()
        this.$nextTick(() => {
          this.$v.preparedData.$each.$iter[index].start_address.$reset()
          this.$v.preparedData.$each.$iter[index].start_city.$reset()
          this.$v.preparedData.$each.$iter[index].start_state.$reset()
          this.$v.preparedData.$each.$iter[index].start_zip.$reset()
        });
      }
      if(input.field.includes('endShiftLocation')) {
        const index = input.field.split("-")[1]
        this.preparedData[index].end_address = input.address
        this.preparedData[index].end_city = input.city
        if(this.states.some(i => i.name === input.state)) {
        this.preparedData[index].end_state = this.states.find(i => i.name === input.state).name
        }
        this.preparedData[index].end_zip = input.zip_code
        this.$refs.endShiftAddress[index].focus()
        this.$nextTick(() => {
          this.$v.preparedData.$each.$iter[index].end_address.$reset()
          this.$v.preparedData.$each.$iter[index].end_city.$reset()
          this.$v.preparedData.$each.$iter[index].end_state.$reset()
          this.$v.preparedData.$each.$iter[index].end_zip.$reset()
        });
      }
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true
      this.serverValidationMessage = 'Oops something went wrong...'
      this.server_errors = {}
    },
    errors: getValMessage(valMessages)(validations)
  }
}
</script>

